import { useEffect, useState } from 'react'

/** Ниже этого порога сжатие области считаем не клавиатурой, а панелями браузера. */
const KEYBOARD_MIN_PX = 150

/**
 * Открыта ли экранная клавиатура.
 *
 * Определяем по visualViewport: при появлении клавиатуры видимая область
 * становится заметно ниже окна. Событий о самой клавиатуре ни браузер, ни
 * Telegram не дают, а focus-события врут — поле можно расфокусить, оставив
 * клавиатуру, и наоборот.
 */
export const useKeyboardOpen = () => {
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return

    const sync = () =>
      setOpen(window.innerHeight - viewport.height > KEYBOARD_MIN_PX)

    sync()
    viewport.addEventListener('resize', sync)
    return () => viewport.removeEventListener('resize', sync)
  }, [])

  return isOpen
}
